export default {
  client_equip_details_revision_history_title: "Histórico de Revisões",
  client_equipaments_title: "Meus Equipamentos",
  client_home_quote_service_card: "Cotar um Serviço",
  client_home_my_quotations_card: "Status dos Serviços",
  client_home_my_equipments_card: "Meus Equipamentos",
  client_quotations_page_title: "Status dos Serviços",
  client_quotations_home_breadcrumb: "Home",
  client_quotations_new_quote_btn: "Nova Cotação",
  client_quotations_pending_section: "Minhas ações",
  client_quotations_processing_section: "Bepi Service",
  client_quotations_finished_section: "Finalizados",
  client_quotations_filter_product_label: "Filtrar por produto",
  client_quotations_filter_all_products: "Todos os produtos",
  client_quotations_view_kanban: "Kanban",
  client_quotations_view_list: "Lista",
  client_quotations_table_product: "Produto",
  client_quotations_no_quotations: "Nenhuma cotação nesta categoria.",
  client_quotations_view_details_btn: "Ver Detalhes",
  client_quotations_refresh_btn: "Atualizar",
  client_quotations_error_loading: "Erro ao carregar cotacoes.",
  client_quote_page_title: "Nova Estimativa",
  client_quote_home_breadcrumb: "Home",
  client_quote_quote_breadcrumb: "Cotar um Serviço",
  client_quote_search_title: "Para qual equipamento busca serviço?",
  client_quote_search_placeholder: "Talabarte",
  client_quote_search_empty_result: "Nenhum servico encontrado para a busca informada.",
  client_quote_success_saving_quote_msg: "Cotação enviada com sucesso!",
  client_quote_catalog_error: "Erro ao carregar catálogo de serviços.",
  client_quote_equipments_error: "Erro ao carregar equipamentos.",
  client_quote_empty_error: "A cotação está vazia. Adicione itens antes de enviar.",
  client_quote_send_error: "Falha ao enviar cotação. Tente novamente.",
  client_quote_cart_delete_title: "Excluir item?",
  client_quote_cart_delete_warning: "Essa ação não pode ser desfeita.",
  client_quote_cart_delete_confirm: "Sim, excluir",
  client_quote_cart_oficina_title: "Manutenção na Oficina",
  client_quote_cart_empresa_title: "InCompany (Na minha empresa)",
  client_quote_cart_item_singular: "item",
  client_quote_cart_item_plural: "itens",
  client_quote_cart_in_oficina_chip: "Na nossa oficina",
  client_quote_cart_in_client_chip: "InCompany (Na minha empresa)",
  client_quote_cart_address_label: "Endereço da manutenção:",
  client_quote_cart_qty_label: "Qtde: ",
  client_quote_cart_model_label: "Modelo: ",
  client_quote_cart_brand_label: "Marca: ",
  client_quote_cart_problem_label: "Problema: ",
  client_quote_cart_tasks_label: "Tarefas: ",
  client_quote_cart_multiple_addresses_title: "Atenção: Múltiplos endereços",
  client_quote_cart_multiple_addresses_text: "Você tem itens para #vr0# endereços diferentes. Cada endereço será considerado uma visita separada.",
  client_quote_cart_page_title: "Estimativa de Orçamento",
  client_quote_cart_home_breadcrumb: "Home",
  client_quote_cart_quote_breadcrumb: "Cotar um Serviço",
  client_quote_cart_empty_title: "Nenhum item adicionado ainda",
  client_quote_cart_empty_subtitle: "Adicione serviços para criar uma cotação",
  client_quote_cart_add_first_btn: "Adicionar Primeiro Item",
  client_quote_cart_total_label: "Total: ",
  client_quote_cart_in_oficina_suffix: " ⬢ #vr0# na oficina",
  client_quote_cart_addresses_suffix: " ⬢ #vr0# #vr1# de empresa",
  client_quote_cart_address_singular: "endereço",
  client_quote_cart_address_plural: "endereços",
  client_quote_cart_add_new_btn: "Adicionar Novo Item",
  client_quote_cart_request_quotes_btn: "Solicitar Cotações",
  client_quote_modal_invalid_qty: "Quantidade inválida",
  client_quote_modal_model_required: "Modelo é obrigatório",
  client_quote_modal_brand_required: "Marca é obrigatória",
  client_quote_modal_problem_required: "Problema é obrigatório",
  client_quote_modal_location_required: "Selecione o local de execução",
  client_quote_modal_address_required: "Endereço obrigatório para manutenção na empresa",
  client_quote_modal_edit_title: "Editando: ",
  client_quote_modal_add_title: "Cotando: ",
  client_quote_modal_default_service: "Serviço",
  client_quote_modal_add_to_quote_btn: "Adicionar à Cotação",
  client_quote_modal_problem_label: "Problema ou necessidade",
  client_quote_modal_problem_placeholder: "Descreva detalhadamente o problema ou necessidade",
  client_quote_modal_location_label: "Local de Execução",
  client_quote_modal_in_oficina_radio: "Oficina (Service)",
  client_quote_modal_in_empresa_radio: "InCompany (Na minha empresa)",
  client_quote_modal_address_label: "Endereço da empresa",
  client_quote_modal_address_placeholder: "Informe o endereço completo onde será realizada a manutenção",
  client_quote_modal_tasks_label: "Escolha o serviço desejado",
  client_quote_modal_obs_edit_label: "Observações",
  client_quote_modal_obs_auto_label: "Observações geradas automaticamente",
  client_quote_modal_obs_helper: "Estas observações serão incluídas na cotação",
  client_quote_search_cart_btn: "Carrinho (#vr0#)",
  client_quote_details_id_error: "Tipo ou ID não encontrado na URL",
  client_quote_details_load_error: "Erro ao carregar detalhes da cotação",
  client_quote_details_num_label: "N° Estimativa:",
  client_quote_details_location_label: "Local:",
  client_quote_details_items_label: "Itens:",
  client_quote_details_value_label: "Valor:",
  client_quote_details_page_title: "Detalhes da Cotação",
  client_quote_details_loading: "Carregando detalhes...",
  client_quote_details_step_summary: "Resumo da Estimativa",
  client_quote_details_step_shipping: "Orientação de Envio",
  client_quote_details_step_invoices: "Anexar Notas de Remessa",
  client_quote_details_step_checkout: "Checkout",
  client_quote_details_shipping_title: "Siga as orientações abaixo antes de enviar os equipamentos.",
  client_quote_details_shipping_reference_title: "Orientações de Envio",
  client_quote_details_shipping_reference_hint: "Clique no botão abaixo para visualizar as orientações completas de envio do equipamento.",
  client_quote_details_shipping_open_page_btn: "Abrir Orientações Completas",
  client_quote_details_shipping_review_checkbox: "Li e compreendi as orientações de envio",
  client_quote_details_invoices_title: "Anexe as notas de remessa para liberar o checkout.",
  client_quote_details_checkout_hint: "Revise as informações finais e conclua o fluxo da cotação.",
  client_quote_details_checkout_invoice_count: "Notas anexadas:",
  client_quote_details_checkout_accept_estimate: "Aceitar Estimativa",
  client_quote_details_checkout_refuse_estimate: "Recusar Estimativa",
  client_quote_details_checkout_accept_budget: "Aprovar Orçamento",
  client_quote_details_checkout_refuse_budget: "Recusar Orçamento",
  client_quote_details_validation_summary: "Resumo da estimativa inválido para avançar.",
  client_quote_details_validation_shipping: "Confirme a leitura das orientações de envio para avançar.",
  client_quote_details_validation_invoices: "Anexe ao menos uma nota de remessa para avançar.",
  client_quote_details_validation_checkout_unavailable: "Ainda não há ação de checkout disponível para esta cotação.",
  client_quote_details_validation_generic: "Não foi possível avançar para a próxima etapa.",
  client_quote_details_refuse_reason_text: "Informe o motivo da recusa:",
  client_quote_details_refuse_reason_placeholder: "Digite o motivo da recusa...",
  client_quote_details_refuse_reason_required: "Por favor, informe o motivo da recusa",
  client_quote_details_refuse_confirm_btn: "Confirmar recusa",
  client_quote_details_refuse_error: "Não foi possível recusar a estimativa.",
  client_quote_details_budget_accept_title: "Aprovar orçamento",
  client_quote_details_budget_accept_text: "Deseja aprovar este orçamento?",
  client_quote_details_budget_accept_confirm: "Aprovar",
  client_quote_details_budget_accept_error: "Não foi possível aprovar o orçamento.",
  client_quote_details_budget_refuse_title: "Recusar orçamento",
  client_quote_details_budget_refuse_error: "Não foi possível recusar o orçamento.",
  client_shipment_title: "Orientacoes de Envio",
  client_shipment_important_warning: "Importante: Se possível imprima e anexe este documento junto ao equipamento. Caso não consiga imprimir, escreva o número da cotação e seu CNPJ na embalagem de forma visível.",
  client_shipment_quote_data_title: "Dados da Cotação",
  client_shipment_estimate_num_label: "Estimativa nº: ",
  client_shipment_cnpj_label: "CNPJ: ",
  client_shipment_sender_title: "Remetente",
  client_shipment_client_label: "Cliente:",
  client_shipment_invoice_data_title: "Dados para emissão da nota fiscal",
  client_shipment_ie_label: "I.E:",
  client_shipment_company_name_label: "Razão Social:",
  client_shipment_address_label: "Endereço:",
  client_shipment_procedure_title: "Procedimento para emissão da Nota de Remessa p/Conserto",
  client_shipment_procedure_step1: "Emitir uma nota fiscal de \"Remessa para Conserto\" CFOP 5915 (estado de SP) ou CFOP 6915 (outros estados).",
  client_shipment_procedure_step2: "Encaminhar a cópia da Nota para o email: fiscal@bunzl.com.br para liberarmos o envio dos equipamentos.",
  client_shipment_procedure_step3: "Lembrando que o envio e a retirada dos equipamentos em nossa unidade são de responsabilidade da empresa contratante do serviço.",
  client_shipment_sedex_warning: "A aceitacao do envio via SEDEX isenta a BUNZL de qualquer responsabilidade quanto a extravio do material. A responsabilidade de postagem e da contratante e dos Correios.",
  client_shipment_certificate_hint: "O equipamento sera retornado com Certificado de Calibracao/Ajuste, acompanhado das devidas Notas Fiscais.",
  client_shipment_important_title: "Importante",
  client_shipment_shipping_costs_warning: "As despesas de envio e retorno não estão incluídas e são de responsabilidade do contratante.",
  client_shipment_refusal_right_warning: "Reservamo-nos o direito de recusar o serviço se, após o exame, o Centro Técnico verificar que o equipamento está em condições irreparáveis ou com danos excessivos.",
  client_shipment_incorrect_nf_warning: "Em caso de envio com Nota Fiscal incorreta, o equipamento será retornado ao endereço informado na NF com frete FOB.",
  client_shipment_doubts_help: "Em caso de dúvidas, entre em contato com nosso atendimento.",
  client_shipment_home_btn: "Voltar para Home",
  client_shipment_print_btn: "Imprimir Instruções",
  client_equip_details_download_error: "Erro ao baixar o laudo.",
  client_equip_details_id_not_found: "ID do equipamento não encontrado",
  client_equip_details_item_data_title: "Dados do Equipamento",
  client_equip_details_latest_photos_title: "Últimas Fotos do Equipamento",
  client_equip_details_not_found: "Equipamento não encontrado",
  client_equipaments_no_equipment_found: "Equipamentos sem equipamento encontrado",
  client_equipaments_quote_pending_btn: "Cotar Pendentes",
  client_home_welcome_question: "O que deseja fazer?",
  client_help_modal_title: "Guia",
  client_help_modal_not_available: "Nenhuma ajuda disponivel para esta tela.",
  client_help_view_client_home_title: "Tela inicial",
  client_help_view_client_home_intro: "Voce esta na tela inicial. Aqui estao as acoes principais disponiveis:",
  client_help_view_client_home_item_quote: "Solicitar uma cotacao de servico.",
  client_help_view_client_home_item_quotations: "Acompanhar o status das suas cotacoes.",
  client_help_view_client_home_item_equipments: "Gerenciar os seus equipamentos.",
  client_help_view_client_quotation_title: "Status dos servicos",
  client_help_view_client_quotation_intro: "Nesta tela voce acompanha suas cotacoes divididas por sessoes e tipos de card.",
  client_help_view_client_quotation_sections_heading: "Sessoes",
  client_help_view_client_quotation_section_waiting: "Minhas acoes: casos que aguardam uma acao sua.",
  client_help_view_client_quotation_section_in_progress: "Bepi Service: casos em processo de execucao.",
  client_help_view_client_quotation_section_finished: "Finalizados: casos que ja foram concluidos.",
  client_help_view_client_quotation_cards_heading: "Tipos de card",
  client_help_view_client_quotation_card_estimate: "Estimativa: proposta com valor estimado do servico.",
  client_help_view_client_quotation_card_budget: "Orcamento: proposta com valor real do servico.",
  client_help_view_client_quotation_card_order: "Pedido: orcamento aprovado e em execucao.",
  client_help_view_client_estimate_title: "Como solicitar cotacao",
  client_help_view_client_estimate_intro: "Siga este fluxo para montar e enviar sua cotacao:",
  client_help_view_client_estimate_step_1: "Escolha o equipamento que deseja cotar.",
  client_help_view_client_estimate_step_2: "Preencha as informacoes do item e adicione ao carrinho.",
  client_help_view_client_estimate_step_3: "Defina o local do servico. Se for na sua empresa, informe o endereco completo.",
  client_help_view_client_estimate_closing: "Pronto. Clique em Solicitar Cotacao para concluir.",
  client_help_view_client_equipments_title: "Meus equipamentos",
  client_help_view_client_equipments_intro: "Aqui voce encontra equipamentos que ja passaram por manutencao.",
  client_help_view_client_equipments_item_history: "Visualizar historico de manutencoes.",
  client_help_view_client_equipments_item_quote: "Solicitar novos servicos.",
  client_help_view_client_equipments_item_photos: "Visualizar fotos do equipamento.",
  client_help_view_client_equipments_item_reports: "Fazer download de laudos tecnicos.",
  client_help_view_client_details_title: "Detalhes da cotacao",
  client_help_view_client_details_intro: "Nesta tela voce acompanha as acoes disponiveis para estimativa e orcamento.",
  client_help_view_client_details_estimate: "Ao receber uma estimativa, voce pode aceitar ou recusar.",
  client_help_view_client_details_budget: "Para o orcamento, voce tambem pode aceitar ou recusar para seguir o fluxo.",
  client_help_view_client_shipping_title: "Orientacoes de envio",
  client_help_view_client_shipping_intro: "Leia com atencao as orientacoes desta pagina antes de enviar o equipamento.",
  client_help_view_client_equipment_details_title: "Detalhes do equipamento",
  client_help_view_client_equipment_details_intro: "Aqui voce encontra informacoes detalhadas sobre equipamento e manutencoes.",
  client_quotations_table_ref: "Ref.",
  client_quotations_table_value: "Valor",
  client_quotations_table_local: "Local",
  client_quotations_view_mode_label: "Visualizacao",
  client_quotations_view_mode_aria_label: "Modo de visualizacao",
  client_quote_details_confirm_btn: "Confirmar",
  client_quote_details_ok_btn: "OK",
  client_quote_details_warning_title: "Atencao",
  client_quote_details_flow_lock_message: "Os proximos passos serao liberados quando a estimativa for entregue.",
  client_quote_details_estimate_accept_title: "Aceitar estimativa",
  client_quote_details_estimate_accept_text: "Confirma o aceite da estimativa para seguir o fluxo?",
  client_quote_details_estimate_accept_confirm: "Confirmar aceite",
  client_quote_details_estimate_accept_success_title: "Estimativa aceita",
  client_quote_details_estimate_accept_success_text: "O aceite da estimativa foi registrado com sucesso.",
  client_quote_details_estimate_accept_error: "Nao foi possivel processar o aceite da estimativa.",
  client_quote_details_estimate_refuse_title: "Recusar estimativa",
  client_quote_details_estimate_refuse_success_title: "Estimativa recusada",
  client_quote_details_budget_refuse_success_title: "Orcamento recusado",
  client_quote_details_refusal_success_message: "A recusa foi registrada com sucesso.",
  client_quote_details_budget_accept_success_title: "Orcamento aprovado",
  client_quote_details_budget_accept_success_text: "Orcamento aprovado com sucesso.",
  client_quote_details_quote_number_title: "Cotacao #vr0#",
  client_quote_details_client_data_title: "Dados do Cliente",
  client_quote_details_client_contact_label: "Contato",
  client_quote_details_client_phone_label: "Telefone",
  client_quote_details_client_email_label: "Email",
  client_quote_details_estimate_data_title: "Dados da Estimativa",
  client_quote_details_response_label: "Resposta",
  client_quote_details_budget_deadline_label: "Prazo",
  client_quote_details_budget_validity_label: "Validade",
  client_quote_details_budget_notes_label: "Observacoes do tecnico",
  client_quote_details_business_days_suffix: "dias uteis",
  client_quote_details_item_fallback: "Item #vr0#",
  client_quote_details_qty_short_label: "Qtd",
  client_quote_details_current_status_title: "Status Atual da Cotacao",
  client_quote_details_no_status: "Sem status",
  client_quote_details_budget_section_title: "Dados do Orcamento",
  client_shipment_loading: "Carregando orientacoes de envio...",
  client_shipment_load_error: "Erro ao carregar orientacoes de envio.",
}

